import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/src/app/manufacturers/page.tsx");
